import { logger } from "@origin-digital/reporting-client";
import { IAppContext } from "../AppContext";
import { findSubcategoryFromLabelIds } from "../helpers/mapping";

export interface IArticleLabel {
  category: string;
  subcategory: string;
}

export const findArticleLabel = (
  articleId: string,
  labels: IAppContext["articleLabels"],
  navigation: IAppContext["navigation"]
): IArticleLabel => {
  const categories = navigation?.data?.categories || [];
  const articleLabels = labels?.data?.articles || [];
  const articleLabelIds = articleLabels.find(
    (label) => articleId === label.articleId
  )?.labelIds;

  if (articleId && labels?.data && !articleLabelIds) {
    logger.error(`findArticleLabel cannot find articleId: ${articleId} `);
  }

  let articleLabel: IArticleLabel = {
    category: "unknown",
    subcategory: "unknown",
  };

  if (articleLabelIds) {
    const subcategory = findSubcategoryFromLabelIds(
      categories,
      articleLabelIds
    );
    if (subcategory?.parentName) {
      articleLabel = {
        category: subcategory.parentName,
        subcategory: subcategory.name,
      };
    } else {
      logger.warn(
        "[findArticleLabel]: could not find matching label for article",
        { articleId }
      );
    }
  }
  return articleLabel;
};
